import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListStatusChangesBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List status changes</div>
          <div className="text">
            Returns a list of status changes. Include parameters to specify board
            and&nbsp;pagination. Sorted by newest.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: "The id of the board you'd like to fetch status changes for.",
                heading: 'boardID',
                subheading: 'string (optional)',
              },
              {
                description:
                  "The number of status changes you'd like to fetch. Defaults to 10 if not specified.",
                heading: 'limit',
                subheading: 'number (optional)',
              },
              {
                description:
                  "The number of status changes you'd like to skip before starting to fetch. Defaults to 0 if not specified.",
                heading: 'skip',
                subheading: 'number (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with a "statusChanges" property that contains an array of status change
            objects. There's also a "hasMore" property that specifies whether this query returns
            more status changes than the&nbsp;limit.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/status_changes/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/status_changes/list"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d boardID=553c3ef8b8cdcd1501ba1234`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "hasMore": false,
  "statusChanges": [{
    "changeComment": {
      "imageURLs": [
        "https://canny.io/images/93fc5808937760b82c3dc00aa5cd86b8.png",
        "https://canny.io/images/316e5600645b81e4be287a52d506dbfd.jpg"
      ],
      "value": "The status has changed!"
    },
    "changer": {
      "id": "553c3ef8b8cdcd1501ba123a",
      "created": "2017-07-15T22:11:00.000Z",
      "email": "test@test.test",
      "isAdmin": false,
      "name": "Sally Doe",
      "url": "https://your-company.canny.io/admin/users/sally-doe",
      "userID": "1234"
    },
    "created": "2017-08-30T13:32:01.000Z",
    "id": "553c3ef8b8cdcd1501ba12bb",
    "post": {
      "id": "553c3ef8b8cdcd1501ba1238",
      "author": {
        "id": "553c3ef8b8cdcd1501ba123a",
        "created": "2017-07-15T22:11:00.000Z",
        "email": "test@test.test",
        "isAdmin": false,
        "name": "Sally Doe",
        "url": "https://your-company.canny.io/admin/users/sally-doe",
        "userID": "1234"
      },
      "board": {
        "created": "2017-07-10T11:22:00.000Z",
        "id": "553c3ef8b8cdcd1501ba1234",
        "name": "Feature Requests",
        "postCount": 123,
        "url": "https://your-company.canny.io/admin/board/feature-requests"
      },
      "category": {
        "id": "553c3ef8b8cdcd1501ba2234",
        "name": "Dashboard",
        "postCount": 42,
        "url": "https://your-company.canny.io/admin/board/feature-requests?category=dashboard"
      },
      "changeComment": {
        "value": "The status has changed!",
        "imageURLs": ["https://canny.io/images/93fc5808937760b82c3dc00aa5cd86b2.png"]
      },
      "commentCount": 10,
      "created": "2017-08-22T13:32:00.000Z",
      "details": "Test post details",
      "eta": "February 2020",
      "imageURLs": [
        "https://canny.io/images/93fc5808937760b82c3dc00aa5cd86b8.png",
        "https://canny.io/images/316e5600645b81e4be287a52d506dbfd.jpg"
      ],
      "jira": {
        "linkedIssues": [{
          "id": "123",
          "key": "ID-123",
          "url": "https://your-company.atlassian.net/browse/ID-123"
        }]
      },
      "linear": {
        "linkedIssueIDs": ["ID-123", "ID-345"],
      },
      "score": 72,
      "status": "in progress",
      "statusChangedAt": "2017-08-24T23:22:00.000Z",
      "tags": [{
        "id": "553c3ef8b8cdcd1501ba3234",
        "name": "iOS",
        "postCount": 15,
        "url": "https://your-company.canny.io/admin/board/feature-requests?tags=ios"
      }],
      "title": "An awesome feature request",
      "url": "https://your-company.canny.io/admin/board/feature-requests/p/an-awesome-feature-request"
    },
    "status": "in progress"
  }]
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
